import {
  addAttachment,
  newModal,
  mergeModalState,
  closeModal,
} from "@js/helpers/state.js";
import { humanReadableSize } from "@js/helpers/text_format.js";

import {
  CE_MODAL_UPLOAD_ATTACHMENT_OPEN,
  CE_MODAL_UPLOAD_ATTACHMENT_SAVE,
  CE_MODAL_UPLOAD_ATTACHMENT_LOAD_FILE,
  CE_MODAL_UPLOAD_ATTACHMENT_OPEN_FILE_PICKER,
  CE_MODAL_UPLOAD_ATTACHMENT_CANCEL_FILE_PICKER,
} from "@js/actions/studio/campaign_content_section/modal_upload_attachment.js";

const validate = (state) => {
  let { size, attachment_name } = state.modal.state;
  let { max_sizes } = state.library;

  // Check against name uniqueness
  let isUniqueName = true;
  let totalSizeAllAttachments = size; //Start off by including our file we're uploading

  state.data.attachments.forEach((otherAttachment) => {
    totalSizeAllAttachments += otherAttachment.size;
    if (otherAttachment.attachment_name === attachment_name) {
      isUniqueName = false;
    }
  });
  if (!isUniqueName) {
    return mergeModalState(state, {
      validation_error: t("phrases.react_content.file_already_exists"),
    });
  }
  if (max_sizes.individual && size > max_sizes.individual) {
    return mergeModalState(state, {
      validation_error: `${t(
        "phrases.react_content.file_too_large",
      )} (${humanReadableSize(size)}).
      ${t("phrases.react_content.maximum_file_size")} ${humanReadableSize(
        max_sizes.individual,
      )}.`,
    });
  }
  if (max_sizes.total && totalSizeAllAttachments > max_sizes.total) {
    return mergeModalState(state, {
      validation_error: `${t(
        "phrases.react_content.maximum_total_file_size",
      )} ${humanReadableSize(max_sizes.total)}.
      ${t(
        "phrases.react_content.uploading_would_exceed_limit",
      )}. (${humanReadableSize(size)}) `,
    });
  }
  return mergeModalState(state, {
    validation_error: null,
  });
};

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_UPLOAD_ATTACHMENT_OPEN:
      return newModal(state, "upload_attachment", {
        picker_is_open: false,
      });

    case CE_MODAL_UPLOAD_ATTACHMENT_LOAD_FILE:
      if (!action || !action.attachment_name || !action.data_base64) {
        return state;
      } else {
        let stateBeforeErrorChecking = mergeModalState(state, {
          //In this process, we can handle erros after the fact, since we maintain the file even if it's too large
          attachment_name: action.attachment_name,
          data_base64: action.data_base64,
          size: action.size,
          picker_is_open: false,
        });
        return validate(stateBeforeErrorChecking);
      }

    case CE_MODAL_UPLOAD_ATTACHMENT_SAVE:
      let { data_base64, attachment_name, size, validation_error } = state.modal.state;
      if (validation_error) return state;
      return addAttachment(closeModal(state), {
        attachment_name: attachment_name,
        data_base64: data_base64,
        size: size,
      });

    case CE_MODAL_UPLOAD_ATTACHMENT_OPEN_FILE_PICKER:
      return mergeModalState(state, {
        picker_is_open: true,
      });

    case CE_MODAL_UPLOAD_ATTACHMENT_CANCEL_FILE_PICKER:
      return mergeModalState(state, {
        picker_is_open: false,
      });

    default:
      return state;
  }
};
